<template>
  <div class="shuju">
    <div class="outmain pad_20 ba_f">
      <div class="pagetitle mar_b20">{{ $t('data.order.title') }}</div>
      <div class="flex-bet">
        <div class="bflex-5 outmain">
          <div class="flex">
            <div class="title35">{{ $t('data.order.orderStats') }}</div>
          </div>
          <div class="flex-bet mar_t10">
            <div>
              <p class="color_6 fon_12">{{ $t('data.order.orderCount') }}</p>
              <p class="fon_24 title35 mar_t5">0</p>
            </div>
            <div>
              <p class="color_6 fon_12">{{ $t('data.order.orderTotalAmount') }}</p>
              <p class="fon_24 title35 mar_t5">0</p>
            </div>
          </div>
          <div>
            <div id="mainEch3" style="height: 260px"></div>
          </div>
        </div>
        <div class="bflex-5">
          <div class="flex-bet mar_t10" v-if="allDataInfo">
            <div class="bortColor flex-bet flex-g-1 pad_20 flex-y-top mar_r20">
              <div>
                <p class="title6 fon_14">{{ $t('data.order.validOrderCount') }}</p>
                <p class="fon_30 title35 lh16 pad_tb_20">{{ allDataInfo.order.today.count }}</p>
                <div class="flex">
                  <p class="fon_12 title6 lh25">{{ $t('data.order.yesterdayFullDay') }} {{ allDataInfo.order.yesterday.count }}</p>
                </div>
              </div>
              <div class="toolTip">
                <el-tooltip effect="dark" placement="top">
                  <div slot="content">{{ $t('data.order.tipValidOrders') }}</div>
                  <button type="button" class="el-button question-button-tooltip el-tooltip el-button--text fon_12">
                    <span>
                      <i class="el-icon-question"></i>
                    </span>
                  </button>
                </el-tooltip>
              </div>
            </div>
            <div class="bortColor flex-bet flex-g-1 pad_20 flex-y-top mar_r20">
              <div>
                <p class="title6 fon_14">{{ $t('data.order.totalAmount') }}</p>
                <p class="fon_30 title35 lh16 pad_tb_20">{{ allDataInfo.order.today.money }}</p>
                <div class="flex">
                  <p class="fon_12 title6 lh25">{{ $t('data.order.yesterdayFullDay') }} {{ allDataInfo.order.yesterday.money }}</p>
                </div>
              </div>
              <div class="toolTip">
                <el-tooltip effect="dark" placement="top">
                  <div slot="content">{{ $t('data.order.tipTotalAmount') }}</div>
                  <button type="button" class="el-button question-button-tooltip el-tooltip el-button--text fon_12">
                    <span>
                      <i class="el-icon-question"></i>
                    </span>
                  </button>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div class="flex-bet mar_t20" v-if="OrderInfo">
            <div class="bortColor flex-bet flex-g-1 pad_20 flex-y-top mar_r20">
              <div>
                <p class="title6 fon_14">{{ $t('data.order.cancelRightsOrders') }}</p>
                <p class="fon_30 title35 lh16 pad_tb_20">{{ OrderInfo.todayCancelNum }}</p>
                <div class="flex">
                  <p class="fon_12 title6 lh25">{{ $t('data.order.yesterdayFullDay') }} {{ OrderInfo.yesterdayCancelNum }}</p>
                </div>
              </div>
              <div class="toolTip">
                <el-tooltip effect="dark" placement="top">
                  <div slot="content">{{ $t('data.order.tipCancelRights') }}</div>
                  <button type="button" class="el-button question-button-tooltip el-tooltip el-button--text fon_12">
                    <span>
                      <i class="el-icon-question"></i>
                    </span>
                  </button>
                </el-tooltip>
              </div>
            </div>
            <div class="bortColor flex-bet flex-g-1 pad_20 flex-y-top mar_r20">
              <div>
                <p class="title6 fon_14">{{ $t('data.order.shopPushCount') }}</p>
                <p class="fon_30 title35 lh16 pad_tb_20">{{ OrderInfo.todayStoreNum }}</p>
                <div class="flex">
                  <p class="fon_12 title6 lh25">{{ $t('data.order.yesterdayFullDay') }} {{ OrderInfo.yesterdayStoreNum }}</p>
                </div>
              </div>
              <div class="toolTip">
                <el-tooltip effect="dark" placement="top">
                  <div slot="content">{{ $t('data.order.tipShopPush') }}</div>
                  <button type="button" class="el-button question-button-tooltip el-tooltip el-button--text fon_12">
                    <span>
                      <i class="el-icon-question"></i>
                    </span>
                  </button>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="outmain pad_20 ba_f bor_rad5 mar_t20" v-if="OrderInfo">
      <div class="shuju_title">
        <div class="shuju_title_text">
          <span>{{ $t('data.order.overview') }}</span>
        </div>
      </div>
      <div class="main-icon flex t_l mar_t20">
        <div class="flex-1 t_l pad_20 bortColor bortColor1">
          <div class="flex-bet flex-y-top">
            <div>
              <p class="title6 fon_14">{{ $t('data.order.pendingAccept') }}</p>
              <p class="fon_30 title35 lh16 pad_tb_20">{{ OrderInfo.handleNum }}</p>
            </div>
            <div class="toolTip">
              <el-tooltip effect="dark" placement="top">
                <div slot="content">{{ $t('data.order.tipPendingAccept') }}</div>
                <button type="button" class="el-button question-button-tooltip el-tooltip el-button--text fon_12">
                  <span>
                    <i class="el-icon-question"></i>
                  </span>
                </button>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="flex-1 t_l pad_20 bortColor bortColor2">
          <div class="flex-bet flex-y-top">
            <div>
              <p class="title6 fon_14">{{ $t('data.order.pendingPickup') }}</p>
              <p class="fon_30 title35 lh16 pad_tb_20">{{ OrderInfo.waitNum }}</p>
            </div>
            <div class="toolTip">
              <el-tooltip effect="dark" placement="top">
                <div slot="content">{{ $t('data.order.tipPendingPickup') }}</div>
                <button type="button" class="el-button question-button-tooltip el-tooltip el-button--text fon_12">
                  <span>
                    <i class="el-icon-question"></i>
                  </span>
                </button>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="flex-1 t_l pad_20 bortColor bortColor6">
          <div class="flex-bet flex-y-top">
            <div>
              <p class="title6 fon_14">{{ $t('data.order.pendingDelivery') }}</p>
              <p class="fon_30 title35 lh16 pad_tb_20">{{ OrderInfo.deliveryNum }}</p>
            </div>
            <div class="toolTip">
              <el-tooltip effect="dark" placement="top">
                <div slot="content">{{ $t('data.order.tipPendingDelivery') }}</div>
                <button type="button" class="el-button question-button-tooltip el-tooltip el-button--text fon_12">
                  <span>
                    <i class="el-icon-question"></i>
                  </span>
                </button>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="flex-1 t_l pad_20 bortColor bortColor3">
          <div class="flex-bet flex-y-top">
            <div>
              <p class="title6 fon_14">{{ $t('data.order.completed') }}</p>
              <p class="fon_30 title35 lh16 pad_tb_20">{{ OrderInfo.completeNum }}</p>
            </div>
            <div class="toolTip">
              <el-tooltip effect="dark" placement="top">
                <div slot="content">{{ $t('data.order.tipCompleted') }}</div>
                <button type="button" class="el-button question-button-tooltip el-tooltip el-button--text fon_12">
                  <span>
                    <i class="el-icon-question"></i>
                  </span>
                </button>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="flex-1 t_l pad_20 bortColor bortColor4">
          <div class="flex-bet flex-y-top">
            <div>
              <p class="title6 fon_14">{{ $t('data.order.cancelOrder') }}</p>
              <p class="fon_30 title35 lh16 pad_tb_20">{{ OrderInfo.cancelNum }}</p>
            </div>
            <div class="toolTip">
              <el-tooltip effect="dark" placement="top">
                <div slot="content">{{ $t('data.order.tipCancelOrder') }}</div>
                <button type="button" class="el-button question-button-tooltip el-tooltip el-button--text fon_12">
                  <span>
                    <i class="el-icon-question"></i>
                  </span>
                </button>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="flex-1 t_l pad_20 bortColor bortColor5">
          <div class="flex-bet flex-y-top">
            <div>
              <p class="title6 fon_14">{{ $t('data.order.afterSales') }}</p>
              <p class="fon_30 title35 lh16 pad_tb_20">{{ OrderInfo.cancelNum }}</p>
            </div>
            <div class="toolTip">
              <el-tooltip effect="dark" placement="top">
                <div slot="content">{{ $t('data.order.tipAfterSales') }}</div>
                <button type="button" class="el-button question-button-tooltip el-tooltip el-button--text fon_12">
                  <span>
                    <i class="el-icon-question"></i>
                  </span>
                </button>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mar_t20 ba_f outmain pad_20">
      <div class="pagetitle mar_b20">{{ $t('data.order.riderBoard') }}</div>
      <div class="flex-bet">
        <div class="bflex-7 outmain" style="height: 390px;">
          <div id="mainEch" style="height:360px"></div>
        </div>
        <div class="bflex-3">
          <div class="bortColor flex-bet pad_20 flex-y-top" v-if="allDataInfo">
            <div>
              <p class="title6 fon_14">{{ $t('data.order.riderAcceptCount') }}</p>
              <p class="fon_30 title35 lh16 pad_tb_20">{{ allDataInfo.rider.today.riderNum }}</p>
              <div class="flex">
                <p class="fon_12 title6 lh25">{{ $t('data.order.yesterday') }} {{ allDataInfo.rider.yesterday.riderNum }}</p>
              </div>
            </div>
            <div class="toolTip">
              <el-tooltip effect="dark" placement="top">
                <div slot="content">{{ $t('data.order.tipRiderAccept') }}</div>
                <button type="button" class="el-button question-button-tooltip el-tooltip el-button--text fon_12">
                  <span>
                    <i class="el-icon-question"></i>
                  </span>
                </button>
              </el-tooltip>
            </div>
          </div>
          <div class="bortColor flex-bet pad_20 flex-y-top mar_t20" v-if="allDataInfo">
            <div>
              <p class="title6 fon_14">{{ $t('data.order.totalRiderCount') }}</p>
              <p class="fon_30 title35 lh16 pad_tb_20">{{ allDataInfo.rider.today.totalRiderNum }}</p>
              <div class="flex">
                <p class="fon_12 title6 lh25">{{ $t('data.order.yesterday') }} {{ allDataInfo.rider.yesterday.totalRiderNum }}</p>
              </div>
            </div>
            <div class="toolTip">
              <el-tooltip effect="dark" placement="top">
                <div slot="content">{{ $t('data.order.tipTotalRider') }}</div>
                <button type="button" class="el-button question-button-tooltip el-tooltip el-button--text fon_12">
                  <span>
                    <i class="el-icon-question"></i>
                  </span>
                </button>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mar_t20 pad_20 ba_f outmain">
      <div class="pagetitle mar_b20">{{ $t('data.order.rankingBoard') }}</div>
      <div class="mar_t20 flex-bet">
        <div class="flex-g-1" style="height: 520px;">
          <div class="flex t_l">
            <div class="title35">{{ $t('data.order.merchantPushTop10') }}</div>
            <div class="toolTip mar_l10">
              <el-tooltip effect="dark" placement="top">
                <div slot="content">{{ $t('data.order.tipMerchantTop10') }}</div>
                <button type="button" class="el-button question-button-tooltip el-tooltip el-button--text fon_12">
                  <span>
                    <i class="el-icon-question"></i>
                  </span>
                </button>
              </el-tooltip>
            </div>
          </div>
          <div class="mar_t10 shuju_table">
            <el-table :data="goodsData" stripe style="width: 100%">
              <el-table-column :label="$t('data.order.rank')">
                <template slot-scope="scope">{{ scope.$index + 1 }}</template>
              </el-table-column>>
              <el-table-column prop="storeName" :label="$t('data.order.merchantName')"></el-table-column>>
              <el-table-column prop="count" :label="$t('data.order.pushCount')"></el-table-column>
              <el-table-column prop="money" :label="$t('data.order.orderAmount')"></el-table-column>
            </el-table>
          </div>
        </div>
        <div class="flex-g-1 mar_l20" style="height: 520px;">
          <div class="flex t_l">
            <div class="title35">{{ $t('data.order.riderAcceptTop10') }}</div>
            <div class="toolTip mar_l10">
              <el-tooltip effect="dark" placement="top">
                <div slot="content">{{ $t('data.order.tipRiderTop10') }}</div>
                <button type="button" class="el-button question-button-tooltip el-tooltip el-button--text fon_12">
                  <span>
                    <i class="el-icon-question"></i>
                  </span>
                </button>
              </el-tooltip>
            </div>
          </div>
          <div class="mar_t10 shuju_table">
            <el-table :data="orderData" stripe style="width: 100%">
              <el-table-column :label="$t('data.order.rank')">
                <template slot-scope="scope">{{ scope.$index + 1 }}</template>
              </el-table-column>>
              <el-table-column prop="realName" :label="$t('data.order.riderName')"></el-table-column>>
              <el-table-column prop="count" :label="$t('data.order.acceptCount')"></el-table-column>
              <el-table-column prop="money" :label="$t('data.order.commission')"></el-table-column>
              <el-table-column prop="distance" :label="$t('data.order.totalDistance')"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getOrderInfo } from '@/api/data.js';
import echarts from 'echarts';

export default {
  data() {
    return {
      OrderInfo: null,
      allDataInfo: null,
      goodsData: [],
      orderData: [],
      echarts1_option: {
        color: ['#4284ED', '#42CCF0'],
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: []
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            show: false,
            lineStyle: {
              color: '#ccc',
              type: 'dashed'
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#333',
              fontSize: '12'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#4ECB73',
              width: 2
            }
          },
          data: []
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#333',
              fontSize: '12'
            }
          },
          splitLine: {
            lineStyle: {
              type: 'dotted',
              color: '#DDDDDD'
            },
            show: true
          }
        },
        series: [
          {
            name: '',
            type: 'line',
            stack: '总量',
            smooth: true,
            data: []
          },
          {
            name: '',
            type: 'line',
            stack: '总量',
            smooth: true,
            data: []
          }
        ]
      },
      echarts1_option3: {
        color: ['#1890FF', '#2FC25B'],
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: []
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            show: false,
            lineStyle: {
              color: '#ccc',
              type: 'dashed'
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#333',
              fontSize: '12'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#4ECB73',
              width: 2
            }
          },
          data: []
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#333',
              fontSize: '12'
            }
          },
          splitLine: {
            lineStyle: {
              type: 'dotted',
              color: '#DDDDDD'
            },
            show: true
          }
        },
        series: [
          {
            name: '',
            type: 'line',
            stack: '总量',
            smooth: true,
            data: []
          },
          {
            name: '',
            type: 'line',
            stack: '总量',
            smooth: true,
            data: []
          }
        ]
      },
      echarts1_option2: {
        color: ['#1890FF', '#2FC25B', '#FBD44B', '#F4667C', '#EBA675'],
        title: {},
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            color: '#aaa'
          }
        },
        legend: {
          data: ['结算金额', '访客数', '支付订单数', '浏览量', '客单价']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            show: false,
            lineStyle: {
              color: '#ccc',
              type: 'dashed'
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#333',
              fontSize: '12'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#4ECB73',
              width: 2
            }
          },
          data: []
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#333',
              fontSize: '12'
            }
          },
          splitLine: {
            lineStyle: {
              type: 'dotted',
              color: '#DDDDDD'
            },
            show: true
          }
        },
        series: [
          {
            name: '结算金额',
            type: 'line',
            stack: '总量',
            data: [],
            smooth: true
          },
          {
            name: '访客数',
            type: 'line',
            stack: '总量',
            data: [],
            smooth: true
          },
          {
            name: '支付订单数',
            type: 'line',
            stack: '总量',
            data: [],
            smooth: true
          },
          {
            name: '浏览量',
            type: 'line',
            stack: '总量',
            data: [],
            smooth: true
          },
          {
            name: '客单价',
            type: 'line',
            stack: '总量',
            data: [],
            smooth: true
          }
        ]
      }
    };
  },
  created() {
    this.getOrder();
  },
  methods: {
    initChartLabels() {
      const riderAccept = this.$t('data.order.chartRiderAccept');
      const totalRider = this.$t('data.order.chartTotalRider');
      const orderCount = this.$t('data.order.chartOrderCount');
      const orderAmount = this.$t('data.order.chartOrderAmount');
      const stackTotal = this.$t('data.order.chartStackTotal');

      this.echarts1_option.legend.data = [riderAccept, totalRider];
      this.echarts1_option.series[0].name = riderAccept;
      this.echarts1_option.series[1].name = totalRider;
      this.echarts1_option.series[0].stack = stackTotal;
      this.echarts1_option.series[1].stack = stackTotal;

      this.echarts1_option3.legend.data = [orderCount, orderAmount];
      this.echarts1_option3.series[0].name = orderCount;
      this.echarts1_option3.series[1].name = orderAmount;
      this.echarts1_option3.series[0].stack = stackTotal;
      this.echarts1_option3.series[1].stack = stackTotal;
    },
    getOrder() {
      getOrderInfo().then((res) => {
        if (res.code == 1) {
          const obj = {
            order: {
              today: res.data.chart.slice(-1)[0],
              yesterday: res.data.chart.slice(-2)[0]
            },
            rider: {
              today: res.data.riderChart.slice(-1)[0],
              yesterday: res.data.riderChart.slice(-2)[0]
            }
          };
          this.allDataInfo = obj;
          res.data.chart.forEach((item, index) => {
            if (index > 7) {
              this.echarts1_option3.xAxis.data.push(item.hours);
              this.echarts1_option3.series[0].data.push(item.count);
              this.echarts1_option3.series[1].data.push(item.money);
            }
          });
          res.data.riderChart.forEach((item) => {
            this.echarts1_option.xAxis.data.push(item.time);
            this.echarts1_option.series[0].data.push(item.riderNum);
            this.echarts1_option.series[1].data.push(item.totalRiderNum);
          });
          this.initChartLabels();
          this.llkb();
          this.jrgk();
          this.OrderInfo = res.data.order;
          this.goodsData = res.data.store;
          this.orderData = res.data.rider;
        }
      });
    },
    jrgk() {
      let myChart = echarts.init(document.getElementById('mainEch3'));
      myChart.setOption(this.echarts1_option3, true);
    },
    llkb() {
      let myChart = echarts.init(document.getElementById('mainEch'));
      myChart.setOption(this.echarts1_option, true);
    },
    handleEdit(row) {
      if (row) {
        this.$refs['edit'].showEdit(row);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.shuju {
  font-family: PingFangSC, 'Microsoft Yahei', Helvetica, Tahoma, Arial, 'Hiragino Sans GB', 'Hiragino Sans GB W3', STXihei, STHeiti, Heiti, SimSun, sans-serif !important;
}

.title6 {
  color: #666;
  font-size: 14px;
}

.title35 {
  color: #353535;
}

.bortColor {
  border: 1px solid #eee;
}

.bortColor1 {
  border-top: 4px solid #1890ff;
}

.bortColor2 {
  border-top: 4px solid #2fc25b;
}

.bortColor3 {
  border-top: 4px solid #fcdb69;
}

.bortColor4 {
  border-top: 4px solid #f4667c;
}

.bortColor5 {
  border-top: 4px solid #eba675;
}

.toolTip .el-button--text {
  color: #b9b9cc;
}

.shuju_title {
  position: relative;
  padding: 10px;
  width: 100%;
  min-height: 40px;
  background-color: #f8f8f8;
}

.shuju_title .shuju_title_text {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  padding-left: 7px;
  font-size: 16px;
  color: #353535;
  line-height: 20px;
}

.shuju_title .shuju_title_text::before {
  position: absolute;
  top: 50%;
  left: 0px;
  transform: translateY(-50%);
  margin-right: 5px;
  content: '';
  display: inline-block;
  height: 14px;
  width: 2px;
  background-color: #2a75ed;
}

.shuju_tips {
  background-color: #ee4141;
  align-items: center;
  padding: 0 20px;
  margin-bottom: 20px;
  width: 100%;
  height: 56px;
}

.bafd {
  background: #fff5ed;
}

.namelogo {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.lhh24 {
  height: 24px;
  line-height: 24px;
}
</style>
<style>
.el-badge__content {
  right: 1px !important;
  height: 22px;
  line-height: 20px;
}
</style>
